// extracted by mini-css-extract-plugin
export default {"box":"calculation-section_box__7OkRb","already":"calculation-section_already__4mRRE","actions":"calculation-section_actions__8UF9P"};